<template>
  <div id="myPageLikedPerformer" class="section">
    <div class="container">
      <h1 class="subtitle is-size-5-desktop is-size-6-touch">
        お気に入りのパフォーマー
        <b-button
          v-if="removeList.length > 0"
          type="normal"
          @click="onClickRefresh"
        >
          <b-icon icon="refresh"></b-icon>
        </b-button>
      </h1>

      <div class="columns is-multiline is-mobile">
        <div
          class="column is-one-quarter-desktop is-one-third-tablet is-half-mobile"
          v-for="(performer, index) in likedPerformers"
          :key="index"
        >
          <div class="thumbnail">
            <router-link :to="`/castinfo/${performer.userId}`">
              <div class="thumbnail-container">
                <b-image
                  class="performer-icon"
                  :src="performer.photoURL"
                  :rounded="true"
                  ratio="60by60"
                />
              </div>
            </router-link>

            <div class="thumbnail-footer-container">
              <div class="thumbnail-footer-content">
                <router-link :to="`/castinfo/${performer.userId}`">{{
                  performer.nickname
                }}</router-link>
                |
                <span
                  class="icon-container"
                  @click="onLikeClicked(performer.userId)"
                >
                  <b-icon
                    :icon="
                      removeList.includes(performer.userId)
                        ? 'heart-outline'
                        : 'heart'
                    "
                    size="is-small"
                    type="is-danger"
                  >
                  </b-icon>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPageLikedPerformer',
  computed: {
    likedPerformers() {
      return this.$store.getters['user/likedPerformers'];
    }
  },
  data() {
    return {
      removeList: []
    };
  },
  methods: {
    onLikeClicked(performerId) {
      if (!this.removeList.includes(performerId)) {
        this.removeList.push(performerId);
      } else {
        const index = this.removeList.indexOf(performerId);
        this.removeList.splice(index, 1);
      }
    },
    async onClickRefresh() {
      await this.removeLikedPerformer();
      this.removeList = [];
    },
    async removeLikedPerformer() {
      const payload = {
        userId: this.$store.state.auth.uid,
        performerIds: this.removeList
      };
      try {
        await this.$store.dispatch('user/removePerformersFromLiked', payload);
      } catch (err) {
        console.error(err);
      }
    }
  },
  async destroyed() {
    return await this.removeLikedPerformer();
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/mypage-liked-performer.scss';
.refresh-icon {
  cursor: pointer;
}
</style>
